import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Booking } from '@luggagehero/shared/interfaces';
import { SharedBookingService } from '@luggagehero/shared/services/bookings';
import { SharedPageTaggingService } from '@luggagehero/shared/services/page-tagging';
import { SharedUserService } from '@luggagehero/shared/services/users';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../../../../core';

@Component({
  template: '',
  standalone: false,
})
export abstract class ManageBookingSelectorBaseComponent extends BaseComponent implements OnInit, OnDestroy {
  private bookingService = inject(SharedBookingService);
  private tag = inject(SharedPageTaggingService);
  private route = inject(ActivatedRoute);
  protected cd = inject(ChangeDetectorRef);

  private _bookingSchemaVersion: number;
  private _isInitialized = false;
  private paramsSubscription: Subscription;
  private readonly userService = inject(SharedUserService);
  private readonly router = inject(Router);

  get legacyMode(): boolean {
    if (this._bookingSchemaVersion > 1) {
      return false;
    }
    return true;
  }

  get isInitialized(): boolean {
    return this._isInitialized;
  }

  ngOnInit() {
    this.paramsSubscription = this.route.params.subscribe((params: { id: string; v: number }) => {
      void (async () => {
        if (!params.id) {
          // TODO: Handle invalid params
          return;
        }
        let booking: Booking = null;
        try {
          booking = await this.bookingService.getBooking(params.id);
          this.tag.addBookingTags(booking);

          this._bookingSchemaVersion = params.v || booking.schemaVersion;
          this._isInitialized = true;
          this.cd.markForCheck();
        } catch (error) {
          if (error && error instanceof HttpErrorResponse) {
            let redirectPath = `/bookings/${params.id}`;
            const httpErrorResponse = error;
            if (httpErrorResponse.status === 401) {
              let queryString = '';
              const queryParams = this.route.snapshot.queryParams;
              if (queryParams && Object.keys(queryParams).length > 0) {
                // Convert the query params to a string
                queryString = Object.keys(queryParams)
                  .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key] as string)}`)
                  .reduce((prev, curr) => {
                    return `${prev ? `${prev}&` : ''}${curr}`;
                  }, '');

                redirectPath += `?${queryString}`;
              }
              void this.router.navigate(['/login']);
              this.userService.showLoginView(true, redirectPath, false, undefined, false);
            }
          }
        }
      })();
    });
  }

  ngOnDestroy() {
    try {
      this.paramsSubscription.unsubscribe();
    } catch {
      // Ignore
    }
  }
}
